import Select from 'react-select';
import { ComboBoxProps } from './ComboBoxCommon';
import { classNames } from '../../../style/common';

export default function ComboBox<
  IsMulti extends boolean,
  ComboBoxOptionValueType
>(
  props: ComboBoxProps<IsMulti, ComboBoxOptionValueType>
) {
  const hasValidationErrors = () => {
    if (!props.required) {
      return false;
    }

    if (!props.selections) {
      return true;
    }

    if (props.selections instanceof Array) {
      return !!!props.selections.length;
    }

    return false;
  }

  return (
    <Select
      isMulti={props.isMulti}
      value={props.selections}
      defaultValue={props.defaultOption}
      onChange={props.onChange}
      options={props.options}
      isSearchable={props.isSearchable}
      onInputChange={props.onInputChange}
      inputValue={props.inputValue}
      blurInputOnSelect={true}
      isClearable={props.isClearable}
      filterOption={props.filterOption}
      menuPlacement='auto'
      menuPortalTarget={document.body}
      classNames={{
        menuPortal: (internalProps) => `!z-[500] !bg-primary ${props.classNames?.menuPortal ? props.classNames.menuPortal(internalProps) : ""}`,
        singleValue: () => "!text-contrast-primary",
        menuList: () => "!bg-secondary",
        menu: () => "!border !border-color-border",
        multiValue: () => "!bg-primary !border !border-color-border/60 !rounded-md",
        multiValueLabel: () => "!text-contrast-primary !rounded-md !leading-4",
        option: () => "!bg-secondary hover:!bg-tertiary !text-contrast-primary !overflow-hidden",
        clearIndicator: (internalProps) => `!rounded-md !py-0`,
        indicatorsContainer: () => "!py-0 !px-1",
        dropdownIndicator: () => "!p-0 !pl-1",
        input: () => "!p-0 !m-0 !text-contrast-primary",
        multiValueRemove: () => "!rounded-r-md !rounded-l-none",
        container: (internalProps) => classNames(
          props.classNames?.container?.(internalProps)
        ),
        control: (internalProps) => classNames(
          `!bg-secondary !text-contrast-primary !rounded-md !border ${props.classNames?.control ? props.classNames.control(internalProps) : ''}`,
          internalProps.isFocused
            ? hasValidationErrors() ? "!border-error-contrast !ring-error-contrast !shadow-none" : "!border-emphasis !ring-emphasis"
            : hasValidationErrors() ? "!border-error-secondary" : "!border-color-border"
        )
      }}
      styles={{
        menuPortal: base => ({ ...base, zIndex: 9999, boxShadow: 'none' }),
        container: (base, internalProps) => ({ ...base, minHeight: "34px", ...(props.styles?.container ? props.styles.container(base, internalProps) : {}) }),
        control: (base, internalProps) => ({ ...base, minHeight: '34px', ...(props.styles?.control ? props.styles.control(base, internalProps) : {}) }),
        input: (base) => ({
          ...base,
          'input:focus': {
            boxShadow: 'none',
          },
        })
      }} />
  );
}